import { render, staticRenderFns } from "./BaseModalControls.vue?vue&type=template&id=ee3c18f0&"
import script from "./BaseModalControls.vue?vue&type=script&lang=js&"
export * from "./BaseModalControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports